// extracted by mini-css-extract-plugin
export default {"EventBox":"Events_EventBox__8p5QD"};